export const OPTION_SERVICE = 1;
export const OPTION_PROOF = 3;
export const OPTION_EDGE = 5;
export const OPTION_FILTER = 6;
export const OPTION_FRAME = 8;
export const OPTION_BORDER = 12;
export const OPTION_LAYOUT = 19;
export const OPTION_BORDER_COLOR = 16;
